import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AdminReceipnestFileS from '../../../components/receipnestFiles/index'
import './style.scss'
const AdmineReceipnestFile = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <AdminReceipnestFileS
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AdmineReceipnestFile
/* AllCasesArea */